// Generated by scripts/agent/sync-meal-break-parser.mjs; edit backend/src/utils/recorded-break.ts.
/** Recorded attendance vocabulary; a scheduled break is never substituted. */
export function recordedBreakMinutes(value: unknown): number {
    const text = String(value ?? '').trim();
    if (/^(?:no\s*break|none|n\/a|)$/i.test(text)) return 0;
    const minutes = text.match(/^(\d+)(?:\s*(?:min|minutes))?$/i);
    if (minutes) return Number(minutes[1]);
    const hour = text.match(/^(\d+)\s*(?:hr|hour)s?\s*walk$/i);
    return hour ? Number(hour[1]) * 60 : 0;
}
